import React from 'react';
import { AuditTab } from 'areas/shared/components';

class AuditInfoTab extends React.Component {
    
    render() {
        let opts = {
            entityType: "CONFIG",            
            helpKey: this.props.helpKey,
            selectedId: this.props.selectedId,
            active: this.props.active,
            test: this.props.active
        };        

        return (
            <React.Fragment>
                <AuditTab {...opts} />
            </React.Fragment>
        );
    }
}

export default AuditInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/appConfig/auditInfo/AuditInfoTab.js